module.exports = __webpack_public_path__ + "media/icons/firma-active@2x-14996fca.png";